import { Dialog, DialogActions, DialogContent, DialogTitle, Paper, PaperProps } from '@mui/material';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { useAppDispatch } from 'Store/index';

import { dialogActions, dialogCancel, dialogContent, dialogTitle } from '../../config/theme/componentTheme';
import { actions } from '../../store/documents/actions';

import ActionButton from '../ActionButton';
import FormRow from '../FormRow';
import InputHandler from '../InputHandler';

const DialogPaper = (props: PaperProps): React.JSX.Element => <Paper square={true} {...props} />;

const MedicationEndDateDialog = ({ document, openState }: IMedicationEndDateDialogProps): React.JSX.Element => {
  const [open, setOpen] = openState;

  const { hasEnded, endDate } = document;

  const [thisFormData, setThisFormData] = React.useState<IEndDate>(endDate ? { endDate } : {}); // Empty object so that dateDefault works
  const [asyncLoading, setAsyncLoading] = React.useState<boolean>(false);

  const onChange = (values: TOnChangeValues): void => {
    const name = Object.keys(values)[0];
    const value = values[name] as string[];
    setThisFormData({
      ...thisFormData,
      [name]: value,
    });
  };

  const dispatch = useAppDispatch();
  const saveHandler = async () => {
    setAsyncLoading(true);
    if (document._id) {
      // Set hasEnded if not been set before
      const hasEndedField = hasEnded?.[0] === true ? {} : { hasEnded: [true] };
      const newData = { ...thisFormData, ...hasEndedField };
      await actions.modifyField({ name: 'medication', id: document._id }, document, newData)(dispatch);
      setOpen(false);
    }
    setAsyncLoading(false);
  };

  return (
    <Dialog open={open} maxWidth={'md'} fullWidth={true} PaperComponent={DialogPaper}>
      <DialogTitle style={dialogTitle}>
        <FormattedMessage id={'medication.endedDate'} />
      </DialogTitle>
      <DialogContent style={dialogContent}>
        <FormRow title="medication.endedDate">
          <InputHandler
            type="PartialDate"
            editing={true}
            name="endDate"
            formData={{ document: thisFormData, onChange: onChange }}
            isNotCancellable
            dateDefault={'now'}
          />
        </FormRow>
      </DialogContent>
      <DialogActions style={dialogActions}>
        <div style={dialogCancel} onClick={(): void => setOpen(false)}>
          <FormattedMessage id="general.cancel" />
        </div>
        <ActionButton
          text="general.save"
          onClick={saveHandler}
          width={15}
          height={4}
          fontSize={16}
          loading={asyncLoading}
          disabled={!thisFormData.endDate}
        />
      </DialogActions>
    </Dialog>
  );
};

interface IEndDate {
  _id?: string;
  hasEnded?: IMedication['hasEnded'];
  endDate?: IMedication['endDate'];
}

interface IMedicationEndDateDialogProps {
  document: IMedication;
  openState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
}

export default MedicationEndDateDialog;
